import 'react-dates/initialize';
import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { closeModal } from 'src/actions/modals';

import Modal from 'react-modal';
import ModalContainer from '../modalContainer';
import { modalStyles } from '../styles';
import { Wrapper, Image } from './style';

const ImageModal = props => {
  const { isOpen, src, dispatch } = props;
  const styles = modalStyles(1000);

  useEffect(() => {
    (async () => {})();
  }, []);

  const close = () => dispatch(closeModal());

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      style={styles}
      closeTimeoutMS={330}
    >
      <ModalContainer closeModal={close}>
        <Wrapper>
          <Image src={src} />
        </Wrapper>
      </ModalContainer>
    </Modal>
  );
};

const map = state => ({
  isOpen: state.modals.isOpen,
});

export default compose(
  // $FlowIssue
  connect(map),
  withRouter
)(ImageModal);
